import styled from 'styled-components';
import { ReactComponent as DiscordSvg } from '../../../images/discord.svg';

export const Container = styled.div``;

export const DiscordSvgg = styled(DiscordSvg)`
  height: 1.5em;
  width: auto;
`;
